<template>
  <div id="addContainer">
    <div class="formWarp">
      <div class="baseInfo" v-if="loadPrjDetail">
        <div class="baseInfo_title">
          <div class="titleAll">项目信息</div>
          <el-form
            ref="formProject"
            :model="formProject"
            :rules="rules"
            label-width="140px"
            label-position="top"
            class="demo-form-inline"
          >
            <el-row :gutter="24" style="margin-bottom: 10px">
              <el-col :span="12">
                <el-form-item label="项目名称" prop="prjName">
                  <el-input v-model="formProject.prjName" :readonly="showType == 'check'" size="small" maxlength="20" show-word-limit clearable />
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item label="项目编号" prop="prjCode">
                  <el-input v-model.trim="formProject.prjCode" :readonly="showType == 'check'" size="small" maxlength="6" show-word-limit clearable 
                  @input="formProject.prjCode = formProject.prjCode.replace(/[\u4E00-\u9FA5]/g,'')"/>
                </el-form-item>
              </el-col> -->
              <!-- <el-col :span="12">
                <el-form-item label="项目类型" prop="prjCategoryId">
                  <el-select v-model="formProject.prjCategoryId" :disabled="showType == 'check'" size="small" clearable style="width: 100%" filterable @change="categoryChange" >
                    <el-option v-for="item in categoryDic" :key="item.id" :label="item.cnName" :value="item.id" />
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="12">
                <template>
                  <el-form-item label="项目总负责人" prop="prjLeaderName">
                    <el-input v-model="formProject.prjLeaderName" readonly size="small">
                      <template slot="append">
                        <el-button :disabled="showType == 'check'" size="small" @click="managerBtn()" > 选择负责人</el-button >
                      </template>
                    </el-input>
                  </el-form-item>
                </template>
              </el-col>
            </el-row>
            <el-row :gutter="24" style="margin-bottom: 10px">
              
              <!-- <el-col :span="8">
                <template>
                  <el-form-item label="承接部门" prop="deptName">
                    <el-input v-model="formProject.deptName" readonly size="small">
                      <template slot="append">
                        <el-button :disabled="showType == 'check'" size="small" @click="departmentBtn()" > 选择承接部门</el-button >
                      </template>
                    </el-input>
                  </el-form-item>
                </template>
              </el-col> -->
              <el-col :span="12">
                <!-- <el-form-item label="项目等级" prop="prjLevelId">
                  <el-select v-model="formProject.prjLevelId" :disabled="showType == 'check'" size="small" style="width: 100%" clearable filterable @change="levelChange" >
                    <el-option v-for="item in levelDic" :key="item.id" :label="item.cnName" :value="item.id" />
                  </el-select>
                </el-form-item> -->
              </el-col>
            </el-row>
            <el-row :gutter="24" style="margin-bottom: 10px">
              <el-col :span="24">
                <el-form-item label="项目概述">
                  <el-input
                    v-model="formProject.prjOverview"
                    :readonly="showType == 'check'"
                    :autosize="{ minRows: 2, maxRows: 6 }"
                    type="textarea"
                    maxlength="200"
                    show-word-limit
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="baseInfo_title">
          <div class="titleAll">详细信息</div>
          <el-form
            ref="formDetail"
            :model="formDetail"
            :rules="formDetailRules"
            label-width="140px"
            label-position="top"
            class="demo-form-inline"
          >
            <el-row :gutter="24">
              <!-- <el-col :span="8">
                <el-form-item label="设计类别" prop="designCategoryId">
                  <el-select
                    v-model="formDetail.designCategoryId"
                    :disabled="showType == 'check'"
                    size="small"
                    style="width: 100%"
                    clearable
                    filterable
                    @change="designChange"
                  >
                    <el-option
                      v-for="item in designDic"
                      :key="item.id"
                      :label="item.cnName"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="12">
                <el-form-item label="所在省市">
                  <el-cascader
                    v-model="formDetail.provinceCity"
                    :props="props"
                    size="small"
                    clearable
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="容积率(%)" prop="plotRatio">
                  <el-input
                    v-model="formDetail.plotRatio"
                    :readonly="showType == 'check'"
                    size="small"
                    type="text"
                    maxlength="10"
                    show-word-limit
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="总建筑面积(㎡)" prop="grossFloorArea">
                  <el-input
                    v-model="formDetail.grossFloorArea"
                    :readonly="showType == 'check'"
                    size="small"
                    type="text"
                    maxlength="10"
                    show-word-limit
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="总用地面积(㎡)" prop="totalLandArea">
                  <el-input
                    v-model="formDetail.totalLandArea"
                    :readonly="showType == 'check'"
                    size="small"
                    type="text"
                    maxlength="10"
                    show-word-limit
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="baseInfo_title">
          <div class="titleAll">时间信息</div>
          <el-form
            ref="formTime"
            :model="formTime"
            label-width="140px"
            label-position="top"
            class="demo-form-inline"
          >
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="计划开始时间">
                  <el-date-picker
                    v-model="formTime.plannedStartTime"
                    :disabled="showType == 'check'"
                    type="datetime"
                    style="width: 100%"
                    size="small"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="startTimeChange"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="计划完成时间">
                  <el-date-picker
                    v-model="formTime.plannedCompletionTime"
                    :disabled="showType == 'check'"
                    :picker-options="endTime"
                    type="datetime"
                    style="width: 100%"
                    size="small"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="showType != 'add'" :gutter="24">
              <el-col :span="8">
                <el-form-item label="最后更新时间">
                  <el-input
                    v-model="formTime.updateDate"
                    :disabled="showType == 'check'"
                    size="small"
                    readonly
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="最后更新者">
                  <el-input
                    v-model="formTime.updateUserName"
                    :disabled="showType == 'check'"
                    size="small"
                    readonly
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <div class="btns">
      <el-button v-if="showType != 'check'" size="small" type="primary" @click="addprojectBtn" >提交 </el-button>
      <el-button size="small" plain @click="projectClose">关闭</el-button>
    </div>
    <!-- 人员 -->
    <el-dialog
      v-dialogDrag
      :visible.sync="peopleVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="peopleClose"
      title="选择人员"
      width="800px"
    >
      <el-form style="height: 40px" @submit.native.prevent>
        <el-form-item>
          <el-input
            v-model="peopleselectName"
            placeholder="请输入姓名或手机号"
            style="width: 200px"
            size="small"
            clearable
            @keyup.enter.native="getPersonList(1)"
          >
            <i slot="prefix" class="el-input__icon el-icon-search" />
          </el-input>
        </el-form-item>
      </el-form>
      <enterprisePerson
        @peopleDetail="peopleDetail"
        :type="2"
        :selectPerson="peopleData"
      ></enterprisePerson>
      <div class="page">
        <el-pagination
          v-if="page1.totalCount > 0"
          :current-page.sync="page1.pageNo"
          :page-size="page1.pageSize"
          :layout="page1.pageLayout"
          :total="page1.totalCount"
          size="small"
          background
          @current-change="peopleselectData"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="peopleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="peopleselsetBtn">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-dialogDrag
      :visible.sync="departmentVisible"
      v-if="departmentVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="departmentClose"
      title="部门"
      width="30%"
      class="people_class"
    >
      <div class="bottom_left">
        <org-tree @orgcurrent="currentOrgChangeHandler" ref="orgTree"></org-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="departmentClose">取 消</el-button>
        <el-button size="small" type="primary" @click="departmentselsetBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import createProjectService from '@/CommonDP/service/project-service'
import systemPersonService from '@/CommonDP/service/enterprisePerson-service'
import projectHome from '@/xgzdService/projectHome-service'
import orgTree from '@/CommonDP/components/structure/orgTree.vue'
import enterprisePerson from '@/CommonDP/components/structure/enterprisePerson.vue'
import { mapState } from 'vuex'
const newEmptyProjectForm = () => ({
  prjCode: '', // 项目编号
  prjCategory: '', // 项目类型
  prjCategoryId: '',
  prjName: '', // 项目名称
  prjLeaderName: '', // 项目负责人
  prjLeaderId: '',
  deptName: '', // 主体部门
  deptId: '',
  prjLevel: '', // 项目等级
  prjLevelId: '',
  prjOverview: '' // 项目概述
})
const newEmptyOwnerForm = () => ({
  ownerName: '', // 业主名称
  ownerContact: '', // 业主联系人
  ownerContactPhone: '' // 业主联系人电话
})
const newEmptyDetailForm = () => ({
  designCategory: '', // 设计类别
  designCategoryId: '',
  provinceCity: [], // 所在省市
  plotRatio: '', // 容积率
  grossFloorArea: '', // 总建筑面积
  totalLandArea: '' // 总用地面积
})
const newEmptyTimeForm = () => ({
  plannedStartTime: '', // 计划开始时间
  plannedCompletionTime: '', // 计划完成时间
  updateDate: '',
  updateUserName: ''
})

export default {
  filters: {
    deptNameDown(list) {
      return list.map(({ deptName }) => deptName).join(';')
    },
    deptNameUp(list) {
      return list.map(({ fullDeptName }) => fullDeptName).join(';')
    }
  },
  components: { orgTree, enterprisePerson },
  data() {
    return {
      formProject: newEmptyProjectForm(),
      formowner: newEmptyOwnerForm(),
      loadPrjDetail: false,
      formDetail: newEmptyDetailForm(),
      formTime: newEmptyTimeForm(),
      rules: {
        prjName: [{ required: true, message: '项目名称不能为空', trigger: 'blur' }],
        // prjCode: [{ required: true, message: '项目编号不能为空', trigger: 'blur' }],
        prjLeaderName: [{ required: true, message: '项目负责人不能为空', trigger: 'change' }],
        prjCategoryId: [{ required: true, message: '项目类型不能为空', trigger: 'change' }],
      },
      formDetailRules: {
        plotRatio: [
          {
            validator: (rule, value, callback) => {
              if (value !== '') {
                if (value >= 0 === false) {
                  callback(new Error('容积率请填写大于0的数字'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        grossFloorArea: [
          {
            validator: (rule, value, callback) => {
              if (value !== '') {
                if (value >= 0 === false) {
                  callback(new Error('总建筑面积请填写大于0的数字'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        totalLandArea: [
          {
            validator: (rule, value, callback) => {
              if (value !== '') {
                if (value >= 0 === false) {
                  callback(new Error('总用地面积请填写大于0的数字'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      endTime: {
        disabledDate: (time) => {
          if (this.formTime.plannedStartTime) {
            return new Date(this.formTime.plannedStartTime).getTime() > time.getTime()
          } else {
            return time.getTime() < Date.now()
          }
        }
      },
      categoryDic: [],
      designDic: [],
      levelDic: [],
      submitType: '',
      showType: '',
      peopleData: [],
      currentRow: {},
      page1: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 0,
        pageLayout: 'total, prev, pager, next,jumper' // 分页组件
      },
      peopleVisible: false,
      peopleselectName: '',
      departmentVisible: false,
      currentDepartment: {},
      roleList: [],
      selectList: [],
      loading: true,
      options: [],
      props: {
        lazy: true,
        label: 'cnName',
        value: 'cnName',
        expandTrigger: 'hover',
        checkStrictly: true,
        async lazyLoad(node, resolve) {
          const { level, data } = node
          let params = {}
          // 获取省以下
          if (level !== 0) {
            params.pid = data.id
          } else {
            params.pid = 0
          }
          params.dicCode = 'Province'
          const res = await projectHome.getProvinceCity(params)
          const list=res.data.map(item=>{
            console.log(level);
            const exist = level===0&&(item.cnName.includes('市')||item.cnName.includes('行政区')||item.cnName.includes('台湾'))
            const existLevel = level===1&&(item.cnName.includes('市')||item.cnName.includes('州')||item.cnName.includes('区')||item.cnName.includes('盟'))
            if(exist||existLevel)return { leaf:true, ...item }
            else return { leaf:false, ...item }
          })
          resolve([...list])
        }
      }
    }
  },
  computed: {
    submitForm() {
      const {
        formProject: {
          prjCode, // 项目编号
          prjCategoryId,
          prjCategory,
          prjName, // 项目名称
          prjLeaderName, // 项目负责人
          prjLeaderId,
          deptName, // 主体部门
          deptId,
          prjLevelId,
          prjLevel,
          prjOverview // 项目概述
        },
        formowner: {
          ownerName, // 业主名称
          ownerContact, // 业主联系人
          ownerContactPhone // 业主联系人电话
        },
        formDetail: {
          provinceCity,
          designCategoryId,
          designCategory,
          plotRatio, // 容积率
          grossFloorArea, // 总建筑面积
          totalLandArea // 总用地面积
        },
        formTime: {
          plannedStartTime, // 计划开始时间
          plannedCompletionTime // 计划完成时间
        },
        enterpriseId
      } = this
      const params = {
        prjCategory: prjCategoryId ? prjCategory : '', // 项目类型
        prjCategoryId,
        prjName, // 项目名称
        prjLeaderName, // 项目负责人
        prjLeaderId,
        deptName, // 主体部门
        deptId,
        prjLevel: prjLevelId ? prjLevel : '', // 项目等级
        prjLevelId,
        ownerName, // 业主名称
        ownerContact, // 业主联系人
        ownerContactPhone, // 业主联系人电话
        designCategory: designCategoryId ? designCategory : '', // 设计类别
        designCategoryId,
        provinceCity: provinceCity ? provinceCity.join('/') : '',
        plotRatio, // 容积率
        grossFloorArea, // 总建筑面积
        totalLandArea, // 总用地面积
        prjOverview, // 项目概述
        plannedStartTime, // 计划开始时间
        plannedCompletionTime, // 计划完成时间
        prjId: this.$route.query.id,
        prjStatusId: this.$route.query.prjStatusId,
        enterpriseId
      }
      if (this.showType === 'add') delete params.prjId, delete params.prjStatusId
      return params
    },
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  async created() {
    const { showType } = this.$route.query
    this.setRouteName(showType)
    if (showType !== 'add') {
      this.loading = true
      await this.queryDetail()
    }
    this.loadPrjDetail = true
    this.categoryDicList()
    this.levelDicList()
    this.designDicList()
  },

  methods: {
    startTimeChange() {
      this.$set(this.formTime, 'plannedCompletionTime', '')
    },
    setRouteName(showType) {
      this.showType = showType
      const routeName = showType === 'add' ? '添加' : showType === 'edit' ? '编辑' : '查看'
      this.$route.meta.routeName = routeName
      this.$store.dispatch('updateNavArr')
    },
    async queryDetail() {
      const { id: prjId } = this.$route.query
      const { data } = await createProjectService.viewList(prjId)
      data.provinceCity = data.provinceCity?.split('/') || []
      data.deptName = Array.isArray(data.undertakeDeptList) ? data.undertakeDeptList[0]?.deptName: ''
      this.formProject = data
      this.formowner = data
      this.formDetail = data
      this.formTime = data
    },
    // 项目类别
    async categoryDicList() {
      const res = await createProjectService.dicList('PrjType')
      this.categoryDic = res.data || []
    },
    // 项目等级
    async levelDicList() {
      const res = await createProjectService.dicList('PrjLevel')
      this.levelDic = res.data || []
    },
    // 设计类别
    async designDicList() {
      const res = await createProjectService.dicList('DesignCategory')
      this.designDic = res.data || []
    },
    async addprojectBtn() {
      await this.$refs.formProject.validate()
      await this.$refs.formDetail.validate()
      const { submitForm: params } = this
      params.deptIds = params.deptId ? [params.deptId]: []
      // delete params.deptId
      if (this.showType === 'edit') {
        await createProjectService.updateCertainEval(params)
        this.$message.success('修改成功')
      } else {
        await projectHome.initiationCreatProject(params)
        this.$message.success('添加成功')
      }
      this.$router.go(-1)
    },
    projectClose() {
      this.$router.go(-1)
    },
    managerBtn(val) {
      this.peopleType = val
      this.peopleVisible = true
      this.getPersonList(1)
      this.page1.pageNo = 1
    },
    peopleDetail(val) {
      this.currentRow = val
    },
    peopleselectData(val) {
      this.getPersonList(val)
      this.currentRow = {}
    },
    // 人员
    async getPersonList(val) {
      this.loading = true
      const {
        page1: { pageSize },
        enterpriseId,
        peopleselectName
      } = this
      const params = {
        pageSize,
        pageNum: val,
        keyword: peopleselectName,
        isEnabled: '',
        enterpriseId
      }
      const { data, totalCount, pageIndex } = await systemPersonService.personListTable(params)
      this.page1.pageIndex = pageIndex
      this.page1.totalCount = totalCount
      this.peopleData = data
      this.loading = false
    },
    peopleselsetBtn() {
      if (this.currentRow) {
        this.formProject.prjLeaderName = this.currentRow.name
        this.formProject.prjLeaderId = this.currentRow.userId
        this.$refs.formProject.clearValidate('prjLeaderName')
      }
      this.peopleVisible = false
      this.currentRow = {}
    },
    peopleClose() {
      this.peopleselectName = ''
      this.peopleVisible = false
      this.currentRow = {}
    },
    // 选择主体部门
    departmentBtn() {
      this.departmentVisible = true
    },
    departmentClose() {
      this.departmentVisible = false
      this.currentDepartment = {}
    },
    currentOrgChangeHandler(val) {
      this.currentDepartment = val
    },
    departmentselsetBtn() {
      if (this.currentDepartment) {
        this.formProject.deptName = this.currentDepartment.deptName
        this.formProject.deptId = this.currentDepartment.deptId
        this.$refs.formProject.clearValidate('deptName')
      }
      this.departmentVisible = false
      this.currentDepartment = {}
    },
    levelChange() {
      for (const item of this.levelDic) {
        if (item.id === this.formProject.prjLevelId) {
          this.formProject.prjLevel = item.cnName
        }
      }
    },
    categoryChange() {
      for (const item of this.categoryDic) {
        if (item.id === this.formProject.prjCategoryId) {
          this.formProject.prjCategory = item.cnName
        }
      }
    },
    designChange() {
      for (const item of this.designDic) {
        if (item.id === this.formDetail.designCategoryId) {
          this.formDetail.designCategory = item.cnName
        }
      }
    }
  }
}
</script>
<style  lang="scss">
.baseInfo_title {
  .el-form--label-top .el-form-item__label {
    padding: 0;
    line-height: 30px;
  }
  .el-form-item {
    margin-bottom: 6px !important;
  }
}
.people_class {
  .el-dialog__body {
    height: 300px;
  }
}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
#addContainer
  width 100%
  height 100%
  background-color #eff1f6
  position relative
  .formWarp
    min-width 1120px
    height 100%
    overflow auto
    padding 0 247px
    box-sizing border-box
    .baseInfo
      width 100%
      padding-bottom 40px
      .baseInfo_title
        background-color #fff
        padding 10px 0
        margin-bottom 10px
  .btns
    height 60px
    display flex
    align-items center
    justify-content center
    background-color #fff
    box-sizing border-box
    position fixed
    bottom 0
    left 70px
    right 0
    padding-right 12px
    border-top 1px solid #EAEAEA
  .demo-form-inline
    padding 20px 40px
  .titleAll
    font-size 16px
    line-height 48px
    color #333333
    padding 0 22px
    font-weight bold
    border-bottom 1px solid rgba(208, 215, 230, 0.75)
  .bottom_left
    height 100%
    overflow auto
</style>
